var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',[_c('v-spacer'),_c('div',{staticClass:"sign-out"},[(_vm.signedIn)?_c('amplify-sign-out',{attrs:{"button-text":"Logout"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }